import React, { ChangeEvent, FC } from "react";
import "./TextInputField.css";

interface TextInputFieldProps {
  label: string;
  placeholder: string;
  onChange: (value: string) => void;
  value?: string;
  type?: "textarea" | "text" | "email";
}

const TextInputField: FC<TextInputFieldProps> = ({
  label,
  placeholder,
  onChange,
  value,
  type = "textarea",
}) => {
  const handleChange = (e: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
    onChange(e.target.value);
  };

  return (
    <div className="textarea-div">
      <label>{label}</label>
      {type === "textarea" ? (
        <textarea 
          placeholder={placeholder} 
          onChange={handleChange}
          value={value}
        />
      ) : (
        <input 
          type={type}
          placeholder={placeholder} 
          onChange={handleChange}
          value={value}
        />
      )}
    </div>
  );
};

export default TextInputField;
